import { render, staticRenderFns } from "./boost-produit.vue?vue&type=template&id=78c4266c&"
import script from "./boost-produit.vue?vue&type=script&lang=js&"
export * from "./boost-produit.vue?vue&type=script&lang=js&"
import style0 from "./boost-produit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports